/* global i18n */

import React from 'react'
import { useSelector } from 'react-redux'
import { flatten, values, reduceBy, prop, pluck, compose, toPairs } from 'ramda'
import { If, Then } from 'react-if'
import s from './style.module.scss'

const Total = ({ paymentType }) => {
  const flatItemList = useSelector((state) => flatten(values(state.Cart.items)))
  const settings = useSelector((state) => state.Cart.settings)

  /*
  input = [
    {currency: 'USD', amount: 20, ...},
    {currency: 'HUF', amount: 4000, ...},
    {currency: 'USD', amount: 20, ...},
    {currency: 'USD', amount: 20, ...}
  ]
  output = {"USD": 60, "HUF": 4000}
  */

  const groupAmountsByCurrency = reduceBy((acc, { amount }) => acc + amount, 0, prop('currency'))

  const prices = compose(toPairs, groupAmountsByCurrency, pluck('commerceinfo'))(flatItemList)
  let fullprice = 0

  for (const [, amount] of prices) {
    fullprice += amount
  }

  if (paymentType === '4') {
    /// crypto wallet
    fullprice *= 1 + settings.cryptoFeeProcent / 10
    fullprice += settings.cryptoFeeFix
    fullprice = fullprice.toFixed(6)
  }

  if (paymentType === '3') {
    // bank payment
    fullprice *= 1 + settings.bankFeeProcent / 10
    fullprice += settings.bankFeeFix
    fullprice = fullprice.toFixed(6)
  }

  return (
    <>
      <div className={s.Total}>
        <h4>{i18n.t('cart_total_amount')}</h4>
        <div className={s.prices}>
          {prices.map(([currency, amount], idx) => (
            <div className={s.price} key={idx}>
              {amount} {currency}
            </div>
          ))}
          <div className={s.plusFee}>
            <If condition={paymentType === '4'}>
              <Then>
                {i18n.t('total_with_crypto_fee')}: {fullprice}
              </Then>
            </If>
            <If condition={paymentType === '3'}>
              <Then>
                {i18n.t('total_with_bank_fee')}: {fullprice}
              </Then>
            </If>
          </div>
        </div>
      </div>
    </>
  )
}

export default Total
